export const simulations = {
  generalError:
    'The requested simulation could not be loaded, please refresh the page and contact support if the issue persists.',
  start: 'Start Simulation',
  reloadForEquipmentWarning:
    'NOTE: If you are missing equipment, refresh your browser and start again.',
};
